import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appProjectLanguage]',
})
export class ProjectLanguageDirective implements OnInit {
    private static readonly RTL_LANGUAGES = ['ar', 'he', 'iw', 'fa', 'ur', 'ps', 'syr', 'dv', 'ku', 'yi', 'ha'];

    @Input('appProjectLanguage') language: string = 'en';

    @HostBinding('attr.dir') direction: 'rtl' | 'ltr' = 'ltr';
    @HostBinding('style.text-align') textAlign: 'right' | 'left' = 'left';

    ngOnInit(): void {
        const baseLang = this.language?.split('-')[0].toLowerCase().trim();
        const isRtl = ProjectLanguageDirective.RTL_LANGUAGES.includes(baseLang);

        this.direction = isRtl ? 'rtl' : 'ltr';
        this.textAlign = isRtl ? 'right' : 'left';
    }
}
